import axios from "axios";
import { encryptPayload, decryptPayload } from "./crypto";
// import { logout } from "../redux/authSlice";
import { logout, setAccessToken } from "../redux/authSlice";
import store from "../redux/store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 100000,
  headers: {
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Encrypt request data
axiosInstance.interceptors.request.use(
  (config) => {
    // const token = sessionStorage.getItem("accessToken");
    
    const state = store.getState();
    const token = state?.auth?.token || sessionStorage.getItem("accessToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.data && !(config.data instanceof FormData)) {
      config.data = { payload: encryptPayload(config.data) };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Decrypt response data and preserve token/refreshToken
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data && response.data.payload) {
      try {
        const decrypted = decryptPayload(response.data.payload);
        if (Array.isArray(decrypted)) {
          // If decrypted is an array, attach tokens as properties (if needed)
          response.data = decrypted;
          if (response.data.token || response.data.refreshToken) {
            // Optionally, you can return an object like { data: [...], token, refreshToken }
            response.data = {
              data: decrypted,
              ...(response.data.token && { token: response.data.token }),
              ...(response.data.refreshToken && {
                refreshToken: response.data.refreshToken,
              }),
            };
          }
        } else {
          // If decrypted is an object, merge as before
          response.data = {
            ...decrypted,
            ...(response.data.token && { token: response.data.token }),
            ...(response.data.refreshToken && {
              refreshToken: response.data.refreshToken,
            }),
          };
        }
      } catch (e) {
        response.data = { error: "Decryption failed" };
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.data?.payload) {
      try {
        const decrypted = decryptPayload(error.response.data.payload);
        error.response.data = decrypted;
      } catch (e) {
        error.response.data = { message: "Error decrypting response." };
        console.error("Failed to decrypt error payload:", e.message);
      }
    }
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message === "Token expired" &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        const refreshToken = sessionStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token available");
        const url = `${process.env.REACT_APP_BASE_URL}/api/auth/refresh`;
        const { data } = await axiosInstance.post(url, { refreshToken });
        // const newAccessToken = data.accessToken;
        // sessionStorage.setItem("token", newAccessToken);
        const newAccessToken = data.accessToken;
sessionStorage.setItem("accessToken", newAccessToken);


store.dispatch(setAccessToken(newAccessToken));
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        store.dispatch(logout());
        sessionStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;


// import axios from "axios";
// import { encryptPayload, decryptPayload } from "./crypto";
// import { logout } from "../redux/authSlice";
// import store from "../redux/store";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_BASE_URL,
//   timeout: 100000,
//   headers: {
//     "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
//     Pragma: "no-cache",
//     Expires: "0",
//   },
// });

// // Encrypt request data
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = sessionStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     if (config.data && !(config.data instanceof FormData)) {
//       config.data = { payload: encryptPayload(config.data) };
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Decrypt response data and preserve token/refreshToken
// axiosInstance.interceptors.response.use(
//   (response) => {
//     if (response.data && response.data.payload) {
//       try {
//         const decrypted = decryptPayload(response.data.payload);
//         if (Array.isArray(decrypted)) {
//           response.data = decrypted;
//           if (response.data.token || response.data.refreshToken) {
//             response.data = {
//               data: decrypted,
//               ...(response.data.token && { token: response.data.token }),
//               ...(response.data.refreshToken && {
//                 refreshToken: response.data.refreshToken,
//               }),
//             };
//           }
//         } else {
//           response.data = {
//             ...decrypted,
//             ...(response.data.token && { token: response.data.token }),
//             ...(response.data.refreshToken && {
//               refreshToken: response.data.refreshToken,
//             }),
//           };
//         }
//       } catch (e) {
//         response.data = { error: "Decryption failed" };
//       }
//     }
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // Decrypt error payload if present
//     if (error.response?.data?.payload) {
//       try {
//         const decrypted = decryptPayload(error.response.data.payload);
//         error.response.data = decrypted;
//       } catch (e) {
//         error.response.data = { message: "Error decrypting response." };
//         console.error("Failed to decrypt error payload:", e.message);
//       }
//     }

//     if (error.response && error.response.status === 401) {
//       const message = error.response.data?.message;

//       // ✅ Case 1: Token expired → try refresh
//       if (message === "Token expired" && !originalRequest._retry) {
//         originalRequest._retry = true;
//         try {
//           const refreshToken = sessionStorage.getItem("refreshToken");
//           if (!refreshToken) throw new Error("No refresh token available");

//           const url = `${process.env.REACT_APP_BASE_URL}/api/auth/refresh`;
//           const { data } = await axiosInstance.post(url, { refreshToken });
//           const newAccessToken = data.accessToken;

//           sessionStorage.setItem("token", newAccessToken);
//           originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//           return axiosInstance(originalRequest);
//         } catch (refreshError) {
//           // Refresh also failed → force logout
//           store.dispatch(logout());
//           sessionStorage.clear();
//           window.location.href = "/login";
//           return Promise.reject(refreshError);
//         }
//       }

//       // ✅ Case 2: No token in sessionStorage (fresh npm run / browser reopen)
//       // Redux still has isAuthenticated:true from persist, but token is gone
//       const token = sessionStorage.getItem("token");
//       if (!token && !originalRequest._retry) {
//         store.dispatch(logout());
//         sessionStorage.clear();
//         window.location.href = "/login";
//         return Promise.reject(error);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;